export default "__VITE_ASSET__BHKDWvkM__"